import { Component, OnInit } from '@angular/core';
import { CommonModule, NgIf } from '@angular/common';
import { DataFetcherService } from '../../../services/data-fetcher/data-fetcher.service';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';

@Component({
  selector: 'app-report-info',
  standalone: true,
  imports: [RouterLink, CommonModule],
  templateUrl: './report-info.component.html',
  styleUrl: './report-info.component.css'
})
export class ReportInfoComponent {
  newUrl: string = '';
  report: any;  // Array to store the list of reports
  reportId: string | undefined; //Get the reportId for API request

  constructor(private dataFetcher: DataFetcherService, private route: ActivatedRoute, private router: Router) {}

  ngOnInit() {
    // Access  the report ID from the route parameters
    this.route.params.subscribe(params => {
      this.reportId = params['reportId'];  // Workspace ID
      this.newUrl = this.router.url.toString().replace('/report/'+this.reportId, '');
    });
    // Fetch the report data when the component initializes
    this.dataFetcher.GetReportByIdData(this.reportId).subscribe(
      (data: any) => {
        // Extract the 'reports' array from the data object
        this.report = data.reports[0] || null;  // Fallback to an empty array if 'reports' is undefined
      },
      (error) => {
        console.error('Error fetching report data', error);
      }
    );
    console.log(this.report);
  }
}

